import createjs from "createjs";
import '../pathseg'
import Box2D from '../box2d'

const map = (function (createjs, Box2D) {

    //.animation-position-helper
    var mainContainer;

    const ART_W = 486
    const ART_H = 445



    var canvas1
    var stage
    var AdobeAn = {}
    var map;
    var rsc;
    var paused;

    var start2dSim;


    (function (cjs, an) {

        var p; // shortcut to reference prototypes
        var lib = {};
        var ss = {};
        var img = {};
        lib.ssMetadata = [
            {
                name: "abox_atlas_",
                frames: [[0, 0, 974, 891], [45, 893, 49, 49], [976, 0, 16, 16], [0, 893, 43, 58]]
            }
];


        // symbols:



        (lib.CachedTexturedBitmap_1 = function () {
            this.initialize(ss["abox_atlas_"]);
            this.gotoAndStop(0);
        }).prototype = p = new cjs.Sprite();



        (lib.CachedTexturedBitmap_2 = function () {
            this.initialize(ss["abox_atlas_"]);
            this.gotoAndStop(1);
        }).prototype = p = new cjs.Sprite();



        (lib.CachedTexturedBitmap_3 = function () {
            this.initialize(img.CachedTexturedBitmap_3);
        }).prototype = p = new cjs.Bitmap();
        p.nominalBounds = new cjs.Rectangle(0, 0, 2299, 2299);


        (lib.CachedTexturedBitmap_4 = function () {
            this.initialize(ss["abox_atlas_"]);
            this.gotoAndStop(2);
        }).prototype = p = new cjs.Sprite();



        (lib.CachedTexturedBitmap_5 = function () {
            this.initialize(ss["abox_atlas_"]);
            this.gotoAndStop(3);
        }).prototype = p = new cjs.Sprite();
        // helper functions:

        function mc_symbol_clone() {
            var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
            clone.gotoAndStop(this.currentFrame);
            clone.paused = this.paused;
            clone.framerate = this.framerate;
            return clone;
        }

        function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
            var prototype = cjs.extend(symbol, cjs.MovieClip);
            prototype.clone = mc_symbol_clone;
            prototype.nominalBounds = nominalBounds;
            prototype.frameBounds = frameBounds;
            return prototype;
        }


        (lib.Symbol5 = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {});

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_5();
            this.instance.parent = this;
            this.instance.setTransform(-0.5, -0.5, 0.5, 0.5);

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        }).prototype = getMCSymbolPrototype(lib.Symbol5, new cjs.Rectangle(-0.5, -0.5, 21.5, 29), null);


        (lib.Symbol2 = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {});

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_3();
            this.instance.parent = this;
            this.instance.setTransform(0, 0, 0.1138, 0.1138);

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        }).prototype = getMCSymbolPrototype(lib.Symbol2, new cjs.Rectangle(0, 0, 261.7, 261.7), null);


        (lib.Oval = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {});

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_2();
            this.instance.parent = this;
            this.instance.setTransform(0, 0, 0.6512, 0.6512);

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        }).prototype = getMCSymbolPrototype(lib.Oval, new cjs.Rectangle(0, 0, 31.9, 31.9), null);


        (lib.Symbol4 = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {});

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_4();
            this.instance.parent = this;
            this.instance.setTransform(6.85, 6.85, 0.4167, 0.4167);

            this.instance_1 = new lib.Oval();
            this.instance_1.parent = this;
            this.instance_1.setTransform(10.25, 10.25, 0.6398, 0.6398, 0, 0, 0, 16, 16);
            this.instance_1.alpha = 0.1992;

            this.timeline.addTween(cjs.Tween.get({}).to({
                state: [{
                    t: this.instance_1
                }, {
                    t: this.instance
                }]
            }).wait(1));

        }).prototype = getMCSymbolPrototype(lib.Symbol4, new cjs.Rectangle(0, 0, 20.4, 20.4), null);


        // stage content:
        (lib.abox = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {
                pin: 1,
                line: 45,
                shape: 147,
                hidePin: 236
            });

            // timeline functions:
            this.frame_0 = function () {
                this.stop();
            }
            this.frame_44 = function () {
                this.stop();
            }
            this.frame_146 = function () {
                this.stop();
            }
            this.frame_235 = function () {
                this.stop()
            }
            this.frame_253 = function () {
                this.stop()
            }

            // actions tween:
            this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(102).call(this.frame_146).wait(89).call(this.frame_235).wait(18).call(this.frame_253).wait(1));

            // Layer_1
            this.instance = new lib.Symbol5();
            this.instance.parent = this;
            this.instance.setTransform(133.15, 117.15, 1, 1, 0, 0, 0, 10.2, 14);
            this.instance._off = true;

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(27).to({
                _off: false
            }, 0).to({
                y: 135.25
            }, 11).wait(1).to({
                y: 132.25
            }, 0).wait(1).to({
                y: 135.25
            }, 0).wait(1).to({
                y: 132.25
            }, 0).wait(1).to({
                y: 135.25
            }, 0).wait(1).to({
                y: 132.25
            }, 0).wait(1).to({
                y: 135.25
            }, 0).wait(191).to({
                y: 112.25,
                alpha: 0
            }, 18).wait(1));

            // Layer_1
            this.instance_1 = new lib.Symbol4();
            this.instance_1.parent = this;
            this.instance_1.setTransform(133.2, 147.95, 0.24, 0.24, 0, 0, 0, 10.4, 10.4);
            this.instance_1._off = true;

            this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({
                _off: false
            }, 0).to({
                regX: 10.3,
                regY: 10.3,
                scaleX: 1.2,
                scaleY: 1.2
            }, 18).to({
                regX: 10.2,
                regY: 10.2,
                scaleX: 1,
                scaleY: 1,
                x: 133.15,
                y: 147.9
            }, 7).wait(209).to({
                alpha: 0
            }, 18).wait(1));

            // mask_idn (mask)
            var mask = new cjs.Shape();
            mask._off = true;
            var mask_graphics_45 = new cjs.Graphics().p("A7DXeIAA7bISTAAIAAzhMAhUAAAIAAThIABAAIAAbbg");
            var mask_graphics_46 = new cjs.Graphics().p("A6oXeIAA7bISTAAIAAzhMAhUAAAIAAThIABAAIAAbbg");
            var mask_graphics_47 = new cjs.Graphics().p("A6NXfIAA7cISTAAIAAzhMAhUAAAIAAThIAAAAIAAbcg");
            var mask_graphics_48 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzhMAhUAAAIAAThIAAAAIAAbcg");
            var mask_graphics_49 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzhMAhUAAAIAAThIAAAAIAAbcg");
            var mask_graphics_50 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzhMAhUAAAIAAThIAAAAIAAbcg");
            var mask_graphics_51 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzgMAhUAAAIAATgIAAAAIAAbbg");
            var mask_graphics_52 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzgMAhUAAAIAATgIAAAAIAAbbg");
            var mask_graphics_53 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzgMAhUAAAIAATgIAAAAIAAbbg");
            var mask_graphics_54 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzhMAhUAAAIAAThIAAAAIAAbcg");
            var mask_graphics_55 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_56 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_57 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_58 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzgMAhUAAAIAATgIAAAAIAAbcg");
            var mask_graphics_59 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzgMAhUAAAIAATgIAAAAIAAbcg");
            var mask_graphics_60 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzgMAhUAAAIAATgIAAAAIAAbcg");
            var mask_graphics_61 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_62 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_63 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_64 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_65 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzgMAhUAAAIAATgIAAAAIAAbcg");
            var mask_graphics_66 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzgMAhUAAAIAATgIAAAAIAAbcg");
            var mask_graphics_67 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzgMAhUAAAIAATgIAAAAIAAbcg");
            var mask_graphics_68 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_69 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_70 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_71 = new cjs.Graphics().p("A5zXeIAA7bISTAAIAAzhMAhUAAAIAAThIAAAAIAAbbg");
            var mask_graphics_72 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzgMAhUAAAIAATgIAAAAIAAbcg");
            var mask_graphics_73 = new cjs.Graphics().p("A5zXfIAA7cISTAAIAAzgMAhUAAAIAATgIAAAAIAAbcg");
            var mask_graphics_74 = new cjs.Graphics().p("A6uXfIAA7cIS9AAIAAzhMAigAAAIAAThIAAAAIAAbcg");
            var mask_graphics_75 = new cjs.Graphics().p("A7qXfIAA7cITnAAIAAzgMAjtAAAIAATgIABAAIAAbcg");
            var mask_graphics_76 = new cjs.Graphics().p("A8lXeIAA7bIURAAIAAzhMAk5AAAIAAThIABAAIAAbbg");
            var mask_graphics_77 = new cjs.Graphics().p("A9gXeIAA7bIU7AAIAAzhMAmFAAAIAAThIABAAIAAbbg");
            var mask_graphics_78 = new cjs.Graphics().p("A+bXeIAA7bIVlAAIAAzgMAnRAAAIAATgIABAAIAAbbg");
            var mask_graphics_79 = new cjs.Graphics().p("A/WXeIAA7bIWOAAIAAzhMAofAAAIAAThIAAAAIAAbbg");
            var mask_graphics_80 = new cjs.Graphics().p("EggRAXeIAA7bIW4AAIAAzgMAprAAAIAATgIAAAAIAAbbg");
            var mask_graphics_81 = new cjs.Graphics().p("EghMAXfIAA7cIXiAAIAAzgMAq3AAAIAATgIAAAAIAAbcg");
            var mask_graphics_82 = new cjs.Graphics().p("EgiIAXfIAA7cIYNAAIAAzhMAsDAAAIAAThIABAAIAAbcg");
            var mask_graphics_83 = new cjs.Graphics().p("EgjDAXfIAA7cIY2AAIAAzgMAtQAAAIAATgIABAAIAAbcg");
            var mask_graphics_84 = new cjs.Graphics().p("Egj+AXfIAA7cIZgAAIAAzhMAucAAAIAAThIABAAIAAbcg");
            var mask_graphics_85 = new cjs.Graphics().p("Egk5AXeIAA7bIaKAAIAAzhMAvoAAAIAAThIABAAIAAbbg");
            var mask_graphics_86 = new cjs.Graphics().p("Egl0AXeIAA7bIa0AAIAAzhMAw0AAAIAAThIABAAIAAbbg");
            var mask_graphics_87 = new cjs.Graphics().p("EgmvAXeIAA7bIbeAAIAAzhMAyBAAAIAAThIAAAAIAAbbg");
            var mask_graphics_88 = new cjs.Graphics().p("EgnrAXeIAA7bIcIAAIAAzhMAzOAAAIAAThIABAAIAAbbg");
            var mask_graphics_89 = new cjs.Graphics().p("EgomAXfIAA7cIcyAAIAAzgMA0aAAAIAATgIABAAIAAbcg");
            var mask_graphics_90 = new cjs.Graphics().p("EgphAXfIAA7cIdcAAIAAzgMA1mAAAIAATgIABAAIAAbcg");
            var mask_graphics_91 = new cjs.Graphics().p("EgqcAXfIAA7cIeGAAIAAzgMA2yAAAIAATgIABAAIAAbcg");
            var mask_graphics_92 = new cjs.Graphics().p("EgrXAXfIAA7cIevAAIAAzgMA3/AAAIAATgIABAAIAAbcg");
            var mask_graphics_93 = new cjs.Graphics().p("EgsSAXfIAA7cIfZAAIAAzhMA5LAAAIAAThIABAAIAAbcg");
            var mask_graphics_94 = new cjs.Graphics().p("EgtNAXeIAA7bMAgDAAAIAAzhMA6YAAAIAAThIAAAAIAAbbg");
            var mask_graphics_95 = new cjs.Graphics().p("EguJAXfIAA7cMAguAAAIAAzhMA7kAAAIAAThIABAAIAAbcg");
            var mask_graphics_96 = new cjs.Graphics().p("EgvEAXeIAA7bMAhXAAAIAAzhMA8xAAAIAAThIABAAIAAbbg");
            var mask_graphics_97 = new cjs.Graphics().p("Egv/AXeIAA7bMAiBAAAIAAzgMA99AAAIAATgIABAAIAAbbg");
            var mask_graphics_98 = new cjs.Graphics().p("Eg8AAXeIAA7bMAqiAAAIAAzhMBNeAAAIAAThIABAAIAAbbg");
            var mask_graphics_99 = new cjs.Graphics().p("Eg8fAWIIAn77MAqhAA7IAcz2MBNbABsIgcT3IACAAIgnb6g");
            var mask_graphics_100 = new cjs.Graphics().p("Eg8/AUxIBQ8aMAqfAB3IA40NMBNYADZIg5UMIACAAIhQcag");
            var mask_graphics_101 = new cjs.Graphics().p("Eg9eATZIB684MAqbACzIBW0iMBNSAFEIhWUiIABAAIh6c3g");
            var mask_graphics_102 = new cjs.Graphics().p("Eg98ASAICk9UMAqXADtIB102MBNJAGxIh1U2IABAAIikdUg");
            var mask_graphics_103 = new cjs.Graphics().p("Eg+ZAQmIDQ9vMAqRAEoICV1JMBM9AIcIiUVKIABAAIjRdvg");
            var mask_graphics_104 = new cjs.Graphics().p("Eg+2APMID++KMAqKAFkIC11dMBMwAKIIi1VbIABABIj+eLg");
            var mask_graphics_105 = new cjs.Graphics().p("Eg/SANyIEt+kMAqBAGfIDW1vMBMhALzIjWVtIABABIktekg");
            var mask_graphics_106 = new cjs.Graphics().p("Eg/uAMWIFe+7MAp3AHZID52AMBMPANdIj5V/IABAAIlee9g");
            var mask_graphics_107 = new cjs.Graphics().p("EhAIAK7IGP/TMApsAITIEc2QMBL6APIIkcWPIACAAImQfUg");
            var mask_graphics_108 = new cjs.Graphics().p("EhAiAJeIHC/pMApfAJOIFA2gMBLkAQyIlAWfIABAAInBfqg");
            var mask_graphics_109 = new cjs.Graphics().p("EhA7AIBIH2/9MApRAKHIFl2uMBLLASbIllWuIACAAIn2f+g");
            var mask_graphics_110 = new cjs.Graphics().p("EhBTAGkMAIqggRMApDALBIGK28MBKwAUEImKW7IABAAMgIqAgSg");
            var mask_graphics_111 = new cjs.Graphics().p("EhBqAFGMAJgggjMAozAL6IGw3JMBKSAVtImwXIIABAAMgJgAgkg");
            var mask_graphics_112 = new cjs.Graphics().p("EhCBADnMAKYggzMAohAMzIHX3VMBJzAXUInYXUIABAAMgKXAg1g");
            var mask_graphics_113 = new cjs.Graphics().p("EhCWACIMALPghCMAoPANrIH/3fMBJQAY7In/XeIABABMgLPAhDg");
            var mask_graphics_114 = new cjs.Graphics().p("EhCrAApMAMIghQMAn7AOjIIo3pMBIsAahIooXoIABABMgMIAhRg");
            var mask_graphics_115 = new cjs.Graphics().p("EhC/gA2MANDghdMAnlAPbIJR3yMBIGAcGIpRXxIABABMgNDAhdg");
            var mask_graphics_116 = new cjs.Graphics().p("EhDSgCWMAN+ghoMAnPAQSIJ735MBHdAdqIp7X5IABAAMgN+Ahog");
            var mask_graphics_117 = new cjs.Graphics().p("EhDkgD3MAO6ghxMAm3ARJIKl4AMBGzAfOIqmX/IABABMgO5Ahxg");
            var mask_graphics_118 = new cjs.Graphics().p("EhD0gFYMAP1gh4MAmfAR/ILQ4GMBGFAgxIrQYFIABAAMgP2Ah5g");
            var mask_graphics_119 = new cjs.Graphics().p("EhEEgG5MAQzgh/MAmEAS1IL94JMBFVAiSIr8YJIABAAMgQzAh+g");
            var mask_graphics_120 = new cjs.Graphics().p("EhETgIbMARxgiDMAlqATqIMo4MMBEkAjzIsoYLIABABMgRxAiCg");
            var mask_graphics_121 = new cjs.Graphics().p("EhEhgJ9MASwgiFMAlNAUeINU4OMBDyAlSItVYOIABAAMgSvAiFg");
            var mask_graphics_122 = new cjs.Graphics().p("EhEugLfMATvgiGMAkwAVSIOB4PMBC9AmxIuCYOIABAAMgTvAiGg");
            var mask_graphics_123 = new cjs.Graphics().p("EhE6gNCMAUvgiFMAkSAWFIOv4OMBCFAoOIuwYNIABABMgUvAiFg");
            var mask_graphics_124 = new cjs.Graphics().p("EhFFgOkMAVwgiDMAjzAW4IPc4MMBBMAppIveYMIABAAMgVwAiCg");
            var mask_graphics_125 = new cjs.Graphics().p("EhFOgQHMAWxgh+MAjRAXpIQL4JMBAQArEIwLYIIABABMgWxAh+g");
            var mask_graphics_126 = new cjs.Graphics().p("EhFXgRgMAXzgh3MAiwAYaIQ54EMA/TAsdIw6YEIAAABMgXyAh3g");
            var mask_graphics_127 = new cjs.Graphics().p("EhFegSoMAY0ghvMAiOAZKIRo3+MA+TAt1IxpX+IABABMgY1Ahvg");
            var mask_graphics_128 = new cjs.Graphics().p("EhFkgTwMAZ3ghlMAhpAZ6ISX34MA9SAvMIyYX3IABABMgZ3Ahlg");
            var mask_graphics_129 = new cjs.Graphics().p("EhFpgU4MAa5ghZMAhFAapITG3wMA8PAwiIzHXuIABABMga6AhZg");
            var mask_graphics_130 = new cjs.Graphics().p("EhFtgV/MAb8ghMMAgfAbXIT23mMA7KAx1Iz3XlIABAAMgb9AhMg");
            var mask_graphics_131 = new cjs.Graphics().p("EhFwgXHMAdAgg8If4cEIUm3aMA6DAzHI0nXZIABABMgdAAg8g");
            var mask_graphics_132 = new cjs.Graphics().p("EhFxgYOMAeDggqIfQcwIVW3OMA46A0XI1XXNIABABMgeDAgqg");
            var mask_graphics_133 = new cjs.Graphics().p("EhFxgZVMAfGggXIendcIWG3AMA3wA1lI2GXAIAAABMgfGAgXg");
            var mask_graphics_134 = new cjs.Graphics().p("EhFwgacMAgKggBId9eGIW22wMA2kA2yI23WxIABABMggKAgBg");
            var mask_graphics_135 = new cjs.Graphics().p("EhFugbiMAhOgfqIdSewIXm2gMA1XA3/I3nWfIABABMghOAfqg");
            var mask_graphics_136 = new cjs.Graphics().p("EhFqgcoMAiRgfQIcnfYIYW2OMA0HA5JI4XWNIABABMgiRAfQg");
            var mask_graphics_137 = new cjs.Graphics().p("EhFlgduMAjUge0Ib7f/IZG16MAy2A6RI5GV6IAAABMgjUAe0g");
            var mask_graphics_138 = new cjs.Graphics().p("EhFfgezMAkYgeXMAbNAgmIZ21lMAxkA7XI53VlIABABMgkYAeXg");
            var mask_graphics_139 = new cjs.Graphics().p("EhFXgf4MAlbgd4MAafAhMIal1OMAwQA8bI6mVPIABABMglbAd4g");
            var mask_graphics_140 = new cjs.Graphics().p("EhFOgg8MAmdgdXMAZxAhxIbU03MAu7A9fI7VU3IAAAAMgmdAdXg");
            var mask_graphics_141 = new cjs.Graphics().p("EhFEgiAMAnggczMAZBAiUIcE0eMAtkA+gI8FUeIABAAMgngAczg");
            var mask_graphics_142 = new cjs.Graphics().p("EhE4gjEMAoigcNMAYQAi3Icz0DMAsMA/eI80UDIABABMgohAcNg");
            var mask_graphics_143 = new cjs.Graphics().p("EhErgkHMApkgbmMAXfAjZIdiznMAqyBAbI9jTnIABABMgpjAbmg");
            var mask_graphics_144 = new cjs.Graphics().p("EhEcglKMAqlga8MAWtAj5IeQzJMApXBBWI+RTKIABABMgqkAa8g");
            var mask_graphics_145 = new cjs.Graphics().p("EhEMgmMMArmgaQMAV6AkYIe+yrMAn7BCQI+/SrIABABMgrlAaQg");
            var mask_graphics_146 = new cjs.Graphics().p("EhEBgnQMAspgZmMAVKAk6IfuyNMAmiBDNI/vSMIABABMgsoAZmg");

            this.timeline.addTween(cjs.Tween.get(mask).to({
                graphics: null,
                x: 0,
                y: 0
            }).wait(45).to({
                graphics: mask_graphics_45,
                x: -173.175,
                y: 5.3
            }).wait(1).to({
                graphics: mask_graphics_46,
                x: -170.5,
                y: 5.75
            }).wait(1).to({
                graphics: mask_graphics_47,
                x: -167.825,
                y: 6.25
            }).wait(1).to({
                graphics: mask_graphics_48,
                x: -165.075,
                y: 6.7
            }).wait(1).to({
                graphics: mask_graphics_49,
                x: -159.775,
                y: 7.15
            }).wait(1).to({
                graphics: mask_graphics_50,
                x: -154.425,
                y: 7.6
            }).wait(1).to({
                graphics: mask_graphics_51,
                x: -149.075,
                y: 8.1
            }).wait(1).to({
                graphics: mask_graphics_52,
                x: -143.725,
                y: 8.55
            }).wait(1).to({
                graphics: mask_graphics_53,
                x: -138.375,
                y: 9
            }).wait(1).to({
                graphics: mask_graphics_54,
                x: -133.025,
                y: 9.5
            }).wait(1).to({
                graphics: mask_graphics_55,
                x: -127.675,
                y: 9.95
            }).wait(1).to({
                graphics: mask_graphics_56,
                x: -122.375,
                y: 10.4
            }).wait(1).to({
                graphics: mask_graphics_57,
                x: -117.025,
                y: 10.85
            }).wait(1).to({
                graphics: mask_graphics_58,
                x: -111.675,
                y: 11.35
            }).wait(1).to({
                graphics: mask_graphics_59,
                x: -106.325,
                y: 11.8
            }).wait(1).to({
                graphics: mask_graphics_60,
                x: -100.975,
                y: 12.25
            }).wait(1).to({
                graphics: mask_graphics_61,
                x: -95.625,
                y: 12.75
            }).wait(1).to({
                graphics: mask_graphics_62,
                x: -90.275,
                y: 13.2
            }).wait(1).to({
                graphics: mask_graphics_63,
                x: -84.975,
                y: 13.65
            }).wait(1).to({
                graphics: mask_graphics_64,
                x: -79.625,
                y: 14.1
            }).wait(1).to({
                graphics: mask_graphics_65,
                x: -74.275,
                y: 14.6
            }).wait(1).to({
                graphics: mask_graphics_66,
                x: -68.925,
                y: 15.05
            }).wait(1).to({
                graphics: mask_graphics_67,
                x: -63.575,
                y: 15.5
            }).wait(1).to({
                graphics: mask_graphics_68,
                x: -58.225,
                y: 16
            }).wait(1).to({
                graphics: mask_graphics_69,
                x: -52.875,
                y: 16.45
            }).wait(1).to({
                graphics: mask_graphics_70,
                x: -47.575,
                y: 16.9
            }).wait(1).to({
                graphics: mask_graphics_71,
                x: -42.225,
                y: 17.35
            }).wait(1).to({
                graphics: mask_graphics_72,
                x: -36.875,
                y: 17.85
            }).wait(1).to({
                graphics: mask_graphics_73,
                x: -31.525,
                y: 18.3
            }).wait(1).to({
                graphics: mask_graphics_74,
                x: -25.2051,
                y: 18.5
            }).wait(1).to({
                graphics: mask_graphics_75,
                x: -18.8853,
                y: 18.75
            }).wait(1).to({
                graphics: mask_graphics_76,
                x: -12.5639,
                y: 18.95
            }).wait(1).to({
                graphics: mask_graphics_77,
                x: -6.294,
                y: 19.15
            }).wait(1).to({
                graphics: mask_graphics_78,
                x: 0.0259,
                y: 19.35
            }).wait(1).to({
                graphics: mask_graphics_79,
                x: 6.3457,
                y: 19.6
            }).wait(1).to({
                graphics: mask_graphics_80,
                x: 12.6656,
                y: 19.8
            }).wait(1).to({
                graphics: mask_graphics_81,
                x: 18.9855,
                y: 20
            }).wait(1).to({
                graphics: mask_graphics_82,
                x: 25.3069,
                y: 20.2
            }).wait(1).to({
                graphics: mask_graphics_83,
                x: 31.5767,
                y: 20.45
            }).wait(1).to({
                graphics: mask_graphics_84,
                x: 37.8966,
                y: 20.65
            }).wait(1).to({
                graphics: mask_graphics_85,
                x: 44.2165,
                y: 20.85
            }).wait(1).to({
                graphics: mask_graphics_86,
                x: 50.5363,
                y: 21.05
            }).wait(1).to({
                graphics: mask_graphics_87,
                x: 56.8562,
                y: 21.3
            }).wait(1).to({
                graphics: mask_graphics_88,
                x: 63.1776,
                y: 21.5
            }).wait(1).to({
                graphics: mask_graphics_89,
                x: 69.4474,
                y: 21.7
            }).wait(1).to({
                graphics: mask_graphics_90,
                x: 75.7673,
                y: 21.9
            }).wait(1).to({
                graphics: mask_graphics_91,
                x: 82.0872,
                y: 22.15
            }).wait(1).to({
                graphics: mask_graphics_92,
                x: 88.4071,
                y: 22.35
            }).wait(1).to({
                graphics: mask_graphics_93,
                x: 94.7269,
                y: 22.55
            }).wait(1).to({
                graphics: mask_graphics_94,
                x: 101.0483,
                y: 22.75
            }).wait(1).to({
                graphics: mask_graphics_95,
                x: 107.3182,
                y: 23
            }).wait(1).to({
                graphics: mask_graphics_96,
                x: 113.638,
                y: 23.2
            }).wait(1).to({
                graphics: mask_graphics_97,
                x: 119.9579,
                y: 23.4
            }).wait(1).to({
                graphics: mask_graphics_98,
                x: 202.1192,
                y: 26.15
            }).wait(1).to({
                graphics: mask_graphics_99,
                x: 205.0315,
                y: 31.7321
            }).wait(1).to({
                graphics: mask_graphics_100,
                x: 208.0615,
                y: 37.3281
            }).wait(1).to({
                graphics: mask_graphics_101,
                x: 211.087,
                y: 42.9887
            }).wait(1).to({
                graphics: mask_graphics_102,
                x: 214.11,
                y: 48.7257
            }).wait(1).to({
                graphics: mask_graphics_103,
                x: 217.1262,
                y: 54.4721
            }).wait(1).to({
                graphics: mask_graphics_104,
                x: 220.1367,
                y: 60.3341
            }).wait(1).to({
                graphics: mask_graphics_105,
                x: 223.1378,
                y: 66.3165
            }).wait(1).to({
                graphics: mask_graphics_106,
                x: 226.1293,
                y: 72.3093
            }).wait(1).to({
                graphics: mask_graphics_107,
                x: 229.1081,
                y: 78.3121
            }).wait(1).to({
                graphics: mask_graphics_108,
                x: 232.0701,
                y: 84.4377
            }).wait(1).to({
                graphics: mask_graphics_109,
                x: 235.0181,
                y: 90.6161
            }).wait(1).to({
                graphics: mask_graphics_110,
                x: 237.946,
                y: 96.9143
            }).wait(1).to({
                graphics: mask_graphics_111,
                x: 240.8548,
                y: 103.2232
            }).wait(1).to({
                graphics: mask_graphics_112,
                x: 243.7385,
                y: 109.542
            }).wait(1).to({
                graphics: mask_graphics_113,
                x: 246.6028,
                y: 116.0233
            }).wait(1).to({
                graphics: mask_graphics_114,
                x: 249.4342,
                y: 122.461
            }).wait(1).to({
                graphics: mask_graphics_115,
                x: 252.1903,
                y: 129.06
            }).wait(1).to({
                graphics: mask_graphics_116,
                x: 255.0178,
                y: 135.6158
            }).wait(1).to({
                graphics: mask_graphics_117,
                x: 257.7591,
                y: 142.3338
            }).wait(1).to({
                graphics: mask_graphics_118,
                x: 260.4659,
                y: 149.0529
            }).wait(1).to({
                graphics: mask_graphics_119,
                x: 263.1342,
                y: 155.8315
            }).wait(1).to({
                graphics: mask_graphics_120,
                x: 265.714,
                y: 162.6603
            }).wait(1).to({
                graphics: mask_graphics_121,
                x: 268.3489,
                y: 169.5412
            }).wait(1).to({
                graphics: mask_graphics_122,
                x: 270.8926,
                y: 176.4762
            }).wait(1).to({
                graphics: mask_graphics_123,
                x: 273.3798,
                y: 183.46
            }).wait(1).to({
                graphics: mask_graphics_124,
                x: 275.8292,
                y: 190.4953
            }).wait(1).to({
                graphics: mask_graphics_125,
                x: 278.1699,
                y: 197.6197
            }).wait(1).to({
                graphics: mask_graphics_126,
                x: 280.5103,
                y: 203.6244
            }).wait(1).to({
                graphics: mask_graphics_127,
                x: 282.8415,
                y: 208.0952
            }).wait(1).to({
                graphics: mask_graphics_128,
                x: 285.062,
                y: 212.5842
            }).wait(1).to({
                graphics: mask_graphics_129,
                x: 287.173,
                y: 217.0848
            }).wait(1).to({
                graphics: mask_graphics_130,
                x: 289.267,
                y: 221.5985
            }).wait(1).to({
                graphics: mask_graphics_131,
                x: 291.347,
                y: 226.1316
            }).wait(1).to({
                graphics: mask_graphics_132,
                x: 293.3072,
                y: 230.719
            }).wait(1).to({
                graphics: mask_graphics_133,
                x: 295.1458,
                y: 235.2224
            }).wait(1).to({
                graphics: mask_graphics_134,
                x: 296.9537,
                y: 239.7853
            }).wait(1).to({
                graphics: mask_graphics_135,
                x: 298.6893,
                y: 244.4038
            }).wait(1).to({
                graphics: mask_graphics_136,
                x: 300.3452,
                y: 248.9302
            }).wait(1).to({
                graphics: mask_graphics_137,
                x: 301.9689,
                y: 253.51
            }).wait(1).to({
                graphics: mask_graphics_138,
                x: 303.4543,
                y: 258.0986
            }).wait(1).to({
                graphics: mask_graphics_139,
                x: 304.8049,
                y: 262.6895
            }).wait(1).to({
                graphics: mask_graphics_140,
                x: 306.1173,
                y: 267.283
            }).wait(1).to({
                graphics: mask_graphics_141,
                x: 307.3835,
                y: 271.8781
            }).wait(1).to({
                graphics: mask_graphics_142,
                x: 308.4554,
                y: 276.4662
            }).wait(1).to({
                graphics: mask_graphics_143,
                x: 309.532,
                y: 281.0556
            }).wait(1).to({
                graphics: mask_graphics_144,
                x: 310.4068,
                y: 285.6391
            }).wait(1).to({
                graphics: mask_graphics_145,
                x: 311.2287,
                y: 290.2221
            }).wait(1).to({
                graphics: mask_graphics_146,
                x: 312.4973,
                y: 294.9992
            }).wait(108));

            // Layer_5
            this.instance_2 = new lib.CachedTexturedBitmap_1();
            this.instance_2.parent = this;
            this.instance_2.setTransform(-0.2, -0.1, 0.5, 0.5);
            this.instance_2._off = true;

            var maskedShapeInstanceList = [this.instance_2];

            for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
                maskedShapeInstanceList[shapedInstanceItr].mask = mask;
            }

            this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(45).to({
                _off: false
            }, 0).wait(209));

            // mask_idn (mask)
            var mask_1 = new cjs.Shape();
            mask_1._off = true;
            var mask_1_graphics_147 = new cjs.Graphics().p("AQGaXICYkSIE5mrQAFgGAAgIIAAAAQAAgIgEgGIAAAAQgFgHgHgDIi0hIIAVhgQABgHgCgGQgDgHgFgEIAAAAQgFgFgHgBIAAAAIgygIIg1lIIAAAAQgCgKgIgGQgIgGgKACIwJCHIiqgMIgGABIiSAcQgJACgGAHIAAAAQgFAHAAAJIAAA6IgXAgIg/AcQgEACgEAEIjUDuQgEAEgCAFIAAAAIgfBsIhcBLQgFAEgDAHIAAAAIgXBJIh+A5IAAAAIgEADIgBAAIh4BgIAAAAIgEAEIAAABIgrA7IAAAAQgDAEgBAFIghCHIAAABIAAABIgVCBImGiCIikhxIhUh7IAmklIAchAIAAAAIACgEIBIk6IAAAAQACgJgDgIIAAAAIhkjIIAAg+QAAgHgDgGIAAAAQgEgGgGgDIAAAAQgGgDgHAAIoHAPQgFAAgFADIgBAAQgEADgEAEIAAAAIgWAdIi7jrIA1g+IDehXIABAAIAGgFIAAAAIByhhQAFgFACgGQACgHgBgGIjjufQBzjwgBiHQAAiCBapIQIQgQGFg6IFNH6IgMAaQgEAIACAJICfKUIAAACIBrHlQADAKAJAGIAAAAQAIAFALgCIPPjeIQXjiIHDUUIAAAAIADAGIAAAAQCZDXD6EJInHMPIgBAAIklIbg");

            this.timeline.addTween(cjs.Tween.get(mask_1).to({
                graphics: null,
                x: 0,
                y: 0
            }).wait(147).to({
                graphics: mask_1_graphics_147,
                x: 243.35,
                y: 221.9625
            }).wait(107));

            // Layer_4
            this.instance_3 = new lib.Symbol2();
            this.instance_3.parent = this;
            this.instance_3.setTransform(133.2, 147.95, 0.1188, 0.1188, 0, 0, 0, 130.8, 130.8);
            this.instance_3._off = true;

            var maskedShapeInstanceList = [this.instance_3];

            for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
                maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
            }

            this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(147).to({
                _off: false
            }, 0).to({
                regX: 130.6,
                regY: 130.6,
                scaleX: 4.3932,
                scaleY: 4.3932,
                x: 132.6,
                y: 155.05
            }, 88, cjs.Ease.cubicOut).wait(19));

        }).prototype = p = new cjs.MovieClip();
        p.nominalBounds = new cjs.Rectangle(0, 0, 486.8, 445.4);
        // library properties:
        lib.properties = {
            id: '1E425790439A4AD0BB931E93742EAA92',
            width: 600,
            height: 600,
            fps: 60,
            color: "#FFFFFF",
            opacity: 1.00,
            manifest: [
                {
                    src: "images/CachedTexturedBitmap_3.png?1588238522702",
                    id: "CachedTexturedBitmap_3"
                },
                {
                    src: "images/abox_atlas_.png?1588238522658",
                    id: "abox_atlas_"
                }
	],
            preloads: []
        };



        // bootstrap callback support:

        (lib.Stage = function (canvas) {
            createjs.Stage.call(this, canvas);
        }).prototype = p = new createjs.Stage();

        p.setAutoPlay = function (autoPlay) {
            this.tickEnabled = autoPlay;
        }
        p.play = function () {
            this.tickEnabled = true;
            this.getChildAt(0).gotoAndPlay(this.getTimelinePosition())
        }
        p.stop = function (ms) {
            if (ms) this.seek(ms);
            this.tickEnabled = false;
        }
        p.seek = function (ms) {
            this.tickEnabled = true;
            this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000);
        }
        p.getDuration = function () {
            return this.getChildAt(0).totalFrames / lib.properties.fps * 1000;
        }

        p.getTimelinePosition = function () {
            return this.getChildAt(0).currentFrame / lib.properties.fps * 1000;
        }

        an.bootcompsLoaded = an.bootcompsLoaded || [];
        if (!an.bootstrapListeners) {
            an.bootstrapListeners = [];
        }

        an.bootstrapCallback = function (fnCallback) {
            an.bootstrapListeners.push(fnCallback);
            if (an.bootcompsLoaded.length > 0) {
                for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
                    fnCallback(an.bootcompsLoaded[i]);
                }
            }
        };

        an.compositions = an.compositions || {};
        an.compositions['1E425790439A4AD0BB931E93742EAA92'] = {
            getStage: function () {
                return exportRoot.getStage();
            },
            getLibrary: function () {
                return lib;
            },
            getSpriteSheet: function () {
                return ss;
            },
            getImages: function () {
                return img;
            }
        };

        an.compositionLoaded = function (id) {
            an.bootcompsLoaded.push(id);
            for (var j = 0; j < an.bootstrapListeners.length; j++) {
                an.bootstrapListeners[j](id);
            }
        }

        an.getComposition = function (id) {
            return an.compositions[id];
        }



        an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
            var lastW, lastH, lastS = 1
            window.addEventListener('resize', resizeCanvas)
            resizeCanvas()
            rsc = resizeCanvas;

            function resizeCanvas() {
                var w = lib.properties.width,
                    h = lib.properties.height
                var iw = window.innerWidth,
                    ih = window.innerHeight
                var pRatio = window.devicePixelRatio || 1,
                    xRatio = iw / w,
                    yRatio = ih / h,
                    sRatio = 1
                if (isResp) {
                    if ((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
                        sRatio = lastS
                    } else if (!isScale) {
                        if (iw < w || ih < h)
                            sRatio = Math.min(xRatio, yRatio)
                    } else if (scaleType == 1) {
                        sRatio = Math.min(xRatio, yRatio)
                    } else if (scaleType == 2) {
                        sRatio = Math.max(xRatio, yRatio)
                    }
                }


                ///////////////////////////
                ///////////////////////////


                var widthHelper = domContainers[1].parentElement
                var whw = widthHelper.offsetWidth
                sRatio = whw / ART_W



                domContainers[0].width = w * pRatio * sRatio
                domContainers[0].height = h * pRatio * sRatio
                domContainers.forEach(function (container) {
                    container.style.width = w * sRatio + 'px'
                    container.style.height = h * sRatio + 'px'
                })
                stage.scaleX = pRatio * sRatio
                stage.scaleY = pRatio * sRatio
                lastW = iw
                lastH = ih
                lastS = sRatio
                stage.tickOnUpdate = false
                stage.update()
                stage.tickOnUpdate = true
                
                   canvas1.style.height = 600 * sRatio/1.25 + 'px'
                canvas1.style.width = 600 * sRatio/1.25 + 'px'
              


                ///////////////////////////////////////////
                ///////////////////////////////////////////
                ///////////////////////////////////////////
                ///////////////////////////////////////////
                ///////////////////////////////////////////

                //REPOSITION

                //console.log(domContainers[1].parentElement.getBoundingClientRect().y,'>>')
                var y = window.innerHeight - ART_H * sRatio
                y /= 2
                    //var parentY=domContainers[1].parentElement.style.top
                var parentY = domContainers[1].parentElement.getBoundingClientRect().y
                y -= parentY
                    //animation-position-helper
                domContainers[1].style.top = y + "px";






            }
        }


    })(createjs, AdobeAn)

    let box = function () {

        var currentProgress = 0

      var path = [193.58, 7.43, 62.91, 18.07, 50.1, 119.9, 33.78, 174.15, 67.08, 310.58, 47.73, 327.34, 15.29, 340.1, 8.48, 348.02, 33.6, 379.66, 37.33, 374.97, 119.8, 372.55, 119.8, 386.43, 134.78, 416.58, 123.77, 464.08, 119.67, 473.45, 114.2, 515.17, 125.91, 532.41, 149.25, 548.48, 203.87, 566.69, 206.59, 549.31, 211.68, 528.67, 218.74, 518.82, 237.16, 504.11, 255.22, 495.86, 258.9, 484.56, 272.94, 473.1, 277.72, 456.9, 309.86, 421, 319.52, 416.51, 322.3, 412.68, 322.3, 400.58, 348.09, 395.57, 373.24, 397.28, 527.15, 377.11, 535.56, 428.19, 546.85, 430.17, 543.15, 447.92, 574.04, 460.37, 525.12, 527.1, 503.61, 565.76, 590.78, 636.34, 632.48, 559.78, 697.8, 447.61, 640.13, 378.8, 639.91, 378.5, 639.75, 378.17, 574.32, 190.91, 424.65, 223.09, 337.52, 243.17, 278.6, 256.27, 262.02, 181.28, 238.52, 83.94, 240.77, 79.28, 196.2, 11.43];
        var density = .1
        var force = .8
            // initial circles, doubled later
        var numCircles = (window.innerWidth< 500)? 100 : 300;
        var X = 3
        var Y = 5

        ////////////////////////////////////

        var MaxSpeed = force
        var doubling = false
        var creating = numCircles
        var exportRoot


        function init_(exportRoot_) {
            exportRoot = exportRoot_
                ///////////////////////////////////////////////// debug draw
            debugDraw = new b2DebugDraw()
                //debugDraw.SetSprite(document.getElementById('canvas1').getContext('2d'))
            debugDraw.SetSprite(canvas1.getContext('2d'))
            
            
            //////////////>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>..
            debugDraw.SetDrawScale(30.0*1.25)

            debugDraw.SetFillAlpha(0)

            debugDraw.SetAlpha(0)
                //debugDraw.SetLineThickness(0);
            debugDraw.SetFlags(b2DebugDraw.e_shapeBit | b2DebugDraw.e_jointBit)
            world.SetDebugDraw(debugDraw)
        }


        var b2Vec2 = Box2D.Common.Math.b2Vec2,
            b2AABB = Box2D.Collision.b2AABB,
            b2BodyDef = Box2D.Dynamics.b2BodyDef,
            b2Body = Box2D.Dynamics.b2Body,
            b2FixtureDef = Box2D.Dynamics.b2FixtureDef,
            b2Fixture = Box2D.Dynamics.b2Fixture,
            b2World = Box2D.Dynamics.b2World,
            b2MassData = Box2D.Collision.Shapes.b2MassData,
            b2PolygonShape = Box2D.Collision.Shapes.b2PolygonShape,
            b2CircleShape = Box2D.Collision.Shapes.b2CircleShape,
            b2EdgeChainDef = Box2D.Collision.Shapes.b2EdgeChainDef,
            b2DebugDraw = Box2D.Dynamics.b2DebugDraw,
            b2Color = Box2D.Common.b2Color,
            b2MouseJointDef = Box2D.Dynamics.Joints.b2MouseJointDef

        var world = new b2World(
            new b2Vec2(0, 0) //gravity
            , true //allow sleep
        )
        var debugDraw
        var fixDef = new b2FixtureDef

        fixDef.density = density
        fixDef.friction = 0
        fixDef.restitution = .999999

        var bodyDef = new b2BodyDef
        bodyDef.type = b2Body.b2_staticBody


        //////////////////////////////////////////////// walls

        fixDef.shape = new b2PolygonShape()
        for (var i = 0; i < path.length; i += 2) {

            var scale = .023

            if (i < (path.length - 2)) {
                var x0 = path[i] * scale
                var y0 = path[i + 1] * scale
                var x1 = path[i + 2] * scale
                var y1 = path[i + 3] * scale
            } else {
                var x0 = path[i] * scale
                var y0 = path[i + 1] * scale
                var j = i - (path.length - 2)

                var x1 = path[j + 0] * scale
                var y1 = path[j + 1] * scale


            }
            fixDef.shape.SetAsEdge(new b2Vec2(x0, y0), new b2Vec2(x1, y1))
            var b = world.CreateBody(bodyDef)
            b.CreateFixture(fixDef)
            b.wall = true
        }


        //////////////////////////////////////////////// contact
        var contactListener = new Box2D.Dynamics.b2ContactListener
        contactListener.BeginContact = function (contact) {
            var manifold = new Box2D.Collision.b2WorldManifold
            contact.GetWorldManifold(manifold)
            var contactPoint = manifold.m_points[0]
                //contactPoint=manifold.m_normal;


            var a = contact.GetFixtureA().GetBody()
            var b = contact.GetFixtureB().GetBody()

            var vel = b.GetLinearVelocity()
                //console.log(vel)
            var speed = vel.Normalize()
                //      console.log(vel,speed)

                var mr=Math.random()
            if (mr > .99) {
                vel.Multiply(MaxSpeed + mr)
                b.SetLinearVelocity(vel)
            }
            // console.log(b.GetLinearVelocity())
            if (a.wall || b.wall) {

                if (a.wall) {

                    var force = .005
                    var ac = contactPoint
                    var bc = b.GetWorldCenter()

                    var dx = ac.x - bc.x
                    var dy = ac.y - bc.y


                    // b.ApplyImpulse(new b2Vec2(Math.random() * force - force / 2, Math.random() * force - force / 2), b.GetWorldCenter());
                    b.ApplyImpulse(new b2Vec2(dx * .01, dy * .01), b.GetWorldCenter())

                }


            } else {

                a.poison = b.poison || a.poison
                b.poison = b.poison || a.poison
            }


            // console.log("+")
            // if else statement here...

        }

        world.SetContactListener(contactListener)


        //   window.setInterval(update, 1000 / 60);


        bodyDef.type = b2Body.b2_dynamicBody
        fixDef.shape = new b2CircleShape(
                .08
            )
            //          bodyDef.position.x = X //Math.random() * 10;
            //          bodyDef.position.y = Y //Math.random() * 10;

        //////////////////////////////////////////////////////////// game tick

        function update(step) {
            if (paused) return
            if (creating > 0) {
                //create some objects

                for (var i = 0; i < 3; ++i) {
                    bodyDef.position.x = X + Math.random() * 3
                    bodyDef.position.y = Y + Math.random() * 3


                    var body = world.CreateBody(bodyDef)
                    body.CreateFixture(fixDef)
                    body.ApplyForce(new b2Vec2(Math.random() * force - force / 2, Math.random() * force - force / 2), body.GetWorldCenter())

                    creating--
                }

            }
            if (doubling) {
                //            for (b = world.m_bodyList; b; b = b.m_next) {
                //
                //
                //            }
                var body = world.m_bodyList

                while (body) {

                    var p = body.GetWorldCenter()

                    bodyDef.position.x = p.x
                    bodyDef.position.y = p.y


                    ///hack
                    if (p.x != 0) {

                        var b = world.CreateBody(bodyDef)
                        b.CreateFixture(fixDef)
                        b.ApplyForce(new b2Vec2(Math.random() * force - force / 2, Math.random() * force - force / 2), b.GetWorldCenter())
                    }
                    body = body.m_next


                }

                doubling = false

            }

            world.Step(1 / 60, 10, 10)
            world.DrawDebugData()
            world.ClearForces()

            window.requestAnimationFrame(update)
        }

        start2dSim = function () {
            window.requestAnimationFrame(update)
        }

        var vec, selectedBody

        function getBodyAtCP() {

            vec = new b2Vec2(X, Y)

            var aabb = new b2AABB()
            aabb.lowerBound.Set(X - 1, Y - 1)
            aabb.upperBound.Set(X + 1, Y + 1)

            // Query the world for overlapping shapes.

            selectedBody = null
            world.QueryAABB(getBodyCB, aabb)
            return selectedBody
        }

        function getBodyCB(fixture) {
            if (fixture.GetBody().GetType() != b2Body.b2_staticBody) {
                // if (fixture.GetShape().TestPoint(fixture.GetBody().GetTransform(), vec)) {
                selectedBody = fixture.GetBody()
                return false
                    //}
            }
            return true
        }


        function next_() {
            rsc();
            switch (currentProgress) {
            case 0:
                window.requestAnimationFrame(update)

                exportRoot.gotoAndPlay('pin')
                break

            case 1:
                exportRoot.gotoAndPlay('line')
                break

            case 2:
                exportRoot.gotoAndPlay('shape')
                break

            case 3:

                exportRoot.gotoAndPlay('hidePin')
                debugDraw.SetFillAlpha(1)
                break


            case 4:
                doubling = true
                break


            case 5:

                var b = getBodyAtCP()
                if (b) {
                    b.poison = true
                }
            }
            currentProgress++


        }

        world.DrawDebugData = function () {
            if (this.m_debugDraw == null) {
                return
            }
            this.m_debugDraw.m_sprite.graphics.clear()
            var flags = this.m_debugDraw.GetFlags()
            var i = 0
            var b
            var f
            var s
            var j
            var bp
            var invQ = new b2Vec2
            var x1 = new b2Vec2
            var x2 = new b2Vec2
            var xf
            var b1 = new b2AABB()
            var b2 = new b2AABB()
            var vs = [new b2Vec2(), new b2Vec2(), new b2Vec2(), new b2Vec2()]
            var color = new b2Color(0, 0, 0)
            if (flags & b2DebugDraw.e_shapeBit) {
                for (b = this.m_bodyList; b; b = b.m_next) {
                    xf = b.m_xf
                    for (f = b.GetFixtureList(); f; f = f.m_next) {
                        s = f.GetShape()

                        if (b.poison) {
                            color.Set(0.7725490196, 0.09019607843, 0.14117647058)
                            this.DrawShape(s, xf, color)
                        } else {
                            color.Set(0.40784313725 , 0.53333333333, 0.47058823529 )


                            this.DrawShape(s, xf, color)
                        }
                    }
                }
            }

        }

        return {
            next: function () {
                next_()
            },
            init: function (rut) {
                init_(rut)
            }
        }
    }()

    var map = function () {
        var canvas, exportRoot, anim_container, dom_overlay_container, fnStartAnimation
        var loadCompleted
        var initialised_
        var loaded_
        var promise_
        var comp

        var loader = new createjs.LoadQueue(false)

        promise_ = new Promise((resolve, reject) => {
            loader.addEventListener('complete', function (evt) {
                resolve(box.next)
                handleComplete(evt, comp)
            })
        })

        function init_(anim_containerParam, canvasParam, canvas1Param, dom_overlay_containerParam) {

            canvas = canvasParam
            canvas1 = canvas1Param
            anim_container = anim_containerParam
            dom_overlay_container = dom_overlay_containerParam
            comp = AdobeAn.getComposition('1E425790439A4AD0BB931E93742EAA92')
            var lib = comp.getLibrary()
                //var loader = new createjs.LoadQueue(false);
            loader.addEventListener('fileload', function (evt) {
                    handleFileLoad(evt, comp)
                })
                //        promise_ = new Promise((resolve, reject) => {
                //            loader.addEventListener("complete", function (evt) {
                //                resolve(box.next);
                //                handleComplete(evt, comp)
                //            });
                //        });
                //        loader.addEventListener("complete", function (evt) {
                //
                //            handleComplete(evt, comp)
                //        });
            var lib = comp.getLibrary()
            loader.loadManifest(lib.properties.manifest)
        }


        function handleFileLoad(evt, comp) {
            var images = comp.getImages()
            if (evt && (evt.item.type == 'image')) {
                images[evt.item.id] = evt.result
            }
        }

        function handleComplete(evt) {
            //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
            var lib = comp.getLibrary()
            var ss = comp.getSpriteSheet()
            var queue = evt.target
            var ssMetadata = lib.ssMetadata
            for (var i = 0; i < ssMetadata.length; i++) {
                ss[ssMetadata[i].name] = new createjs.SpriteSheet({
                    'images': [queue.getResult(ssMetadata[i].name)],
                    'frames': ssMetadata[i].frames
                })
            }
            exportRoot = new lib.abox()
            stage = new lib.Stage(canvas)
                //Registers the "tick" event listener.
            fnStartAnimation = function () {
                    stage.addChild(exportRoot)
                    createjs.Ticker.setFPS(lib.properties.fps)
                    createjs.Ticker.addEventListener('tick', stage)
                }
                //Code to support hidpi screens and responsive scaling.
            AdobeAn.makeResponsive(true, 'both', false, 1, [canvas, anim_container, dom_overlay_container, canvas1])
            AdobeAn.compositionLoaded(lib.properties.id)
            fnStartAnimation()
            box.init(exportRoot)
            loadCompleted = true
        }

        function pause_(toPause) {
            toPause = toPause === undefined
            if (!loadCompleted) return;
            //            if(toPause){
            //                createjs.Ticker.removeEventListener('tick', stage);
            //            }else{
            //                createjs.Ticker.addEventListener('tick', stage);
            //                
            //            }
            rsc();
            paused = toPause;
            if (!paused)
                start2dSim();
        }

        return {
            pause: pause_,
            init: init_,
            ready: promise_

        }
    }()





    return map
})(createjs, Box2D, )

export default map;